const CONTAINER_ATTR = "data-palazzo-vinci-widget"

export function createWidgetFrame(
  src: string,
  containerId?: string,
): { iframe: HTMLIFrameElement; container: HTMLDivElement } {
  const host = containerId ? document.getElementById(containerId) : null
  const container = document.createElement("div")
  container.setAttribute(CONTAINER_ATTR, "")
  container.style.cssText = [
    "position:fixed",
    "right:24px",
    "bottom:24px",
    "width:min(400px,calc(100vw - 32px))",
    "height:min(640px,calc(100vh - 48px))",
    "z-index:2147483646",
    "border-radius:16px",
    "overflow:hidden",
    "box-shadow:0 24px 64px rgba(0,0,0,0.24)",
    "background:#fff",
  ].join(";")

  if (host) {
    host.appendChild(container)
  } else {
    document.body.appendChild(container)
  }

  const iframe = document.createElement("iframe")
  iframe.src = src
  iframe.title = "Vinci shopping assistant"
  iframe.style.cssText = "width:100%;height:100%;border:0;display:block;"
  iframe.setAttribute("allow", "clipboard-read; clipboard-write")
  // allow-popups-to-escape-sandbox: product click-outs open partner pages via
  // window.open — without it those pages inherit the sandbox restrictions.
  iframe.setAttribute(
    "sandbox",
    "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox",
  )
  iframe.setAttribute("referrerpolicy", "no-referrer")
  container.appendChild(iframe)

  return { iframe, container }
}

export function removeWidgetFrame(
  iframe: HTMLIFrameElement,
  container: HTMLDivElement,
) {
  iframe.remove()
  container.remove()
}
